import React, { useEffect, useState } from 'react';
import HeaderFFF from '../../components/HeaderFFF'
import Header from '../../components/Header'
import Footer from "../../components/Footer";
import { Link } from 'react-router-dom';
import '../../styles/injury.css'

export default function PersonalInjury() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
    
        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 991);
            };
    
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);
    
        return(
            <>
            {isMobile ? <Header /> : <HeaderFFF />}
        <div id="injury">
            <div id="inj-header-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <h2>Personal Injury</h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div id="inj-text">
                <p>Our personal injury department has a lot to offer if you are looking for a personal injury law firm specializing in<br/> a wide range of practices. Our experienced injury lawyers ensure you receive fulfilling professional assistance<br/> for the following law services in the GTA and surrounding locations:</p>
            </div>

            {/* CONTAINERS SECTION 1 */}
            <div className="inj-container-R">
                <img src="/img/fields/injury/inj1.png" alt="A person walking"></img>
                <div className="inj-content-R">
                    <h3 className="inj-content-header">Slip & Fall</h3>
                    <p className="inj-content-text">Improperly maintained properties, wet surfaces and risky sidewalks are<br/> open invitations for slip.</p>
                    <button className="field-btn"><Link to="/fields-of-expertise/personal-injury/slip-and-fall-accidents">LEARN MORE</Link></button>
                </div>
            </div>
            {/* CONTAINERS SECTION 2 */}
            <div className="inj-container-L">
                <div className="inj-content-L">
                    <h3 className="inj-content-header">Car Accidents</h3>
                    <p className="inj-content-text">It could be a highly traumatic event for the victim as it could involve<br/> pain and suffering, loss of income, long-term disabilities, and<br/> sometimes even death.</p>
                    <button className="field-btn"><Link to="/fields-of-expertise/personal-injury/car-accidents">LEARN MORE</Link></button>
                </div>
                <img src="/img/fields/injury/inj2.png" alt="A tree branch on a car"></img>
            </div>
            {/* CONTAINERS SECTION 3 */}
            <div className="inj-container-R">
                <img src="/img/fields/injury/pi1.png" alt="A car crash"></img>
                <div className="inj-content-R">
                    <h3 className="inj-content-header">Accident Benefit</h3>
                    <p className="inj-content-text">When car accidents occur, an accident benefits lawyer in Toronto can help secure victims the
compensation they are entitled to.</p>
<button className="field-btn"><Link to="/fields-of-expertise/personal-injury/accident-benefit-claims">LEARN MORE</Link></button>
                </div>
            </div>
            {/* CONTAINERS SECTION 4 */}
            <div className="inj-container-L">
                <div className="inj-content-L">
                    <h3 className="inj-content-header">Wrongful Death</h3>
                    <p className="inj-content-text">Besides the irreplaceable grief and heartache, death of a dependent<br/> family member can also lead to financial setbacks.</p>
                    <button className="field-btn"><Link to="/fields-of-expertise/personal-injury/wrongful-death">LEARN MORE</Link></button>
                </div>
                <img src="/img/fields/injury/inj4.png" alt="A person mourning next to a grave"></img>
            </div>
            {/* CONTAINERS SECTION 5 */}
            <div className="inj-container-R">
                <img src="/img/fields/injury/inj6.png" alt="A wheelchair"></img>
                <div className="inj-content-R">
                    <h3 className="inj-content-header">Catastrophic Injuries</h3>
                    <p className="inj-content-text">Sufferers commonly go through severe emotional trauma and face high<br/>medical costs for injuries that cause lifetime disability.</p>
                    <button className="field-btn"><Link to="/fields-of-expertise/personal-injury/catastrophic-injuries">LEARN MORE</Link></button>
                </div>
            </div>
            {/* CONTAINERS SECTION 6 */}
            <div className="inj-container-L">
                <div className="inj-content-L">
                    <h3 className="inj-content-header">Insurance Litigation</h3>
                    <p className="inj-content-text">When an injury occurs in an accident, insurance litigation lawyers can be essential for
securing the benefits that are needed to cover medical expenses and recover from the injury.</p>
<button className="field-btn"><Link to="/fields-of-expertise/personal-injury/insurance-litigation">LEARN MORE</Link></button>
                </div>
                <img src="/img/fields/injury/pi2.png" alt="A calculator on paperwork"></img>
            </div>
            {/* CONTAINERS SECTION 7 */}
            <div className="inj-container-R">
                <img src="/img/fields/injury/pi3.png" alt="A disastrous car crash"></img>
                <div className="inj-content-R">
                    <h3 className="inj-content-header">Fatal Accident Compensation Claims</h3>
                    <p className="inj-content-text">Anyone who has unexpectedly lost a loved one in a fatal accident can rest assured that the fatal
accident lawyers at CLV will be there to assist them with filing fatal accident compensation
claims.</p>
                    <button className="field-btn"><Link to="/fields-of-expertise/personal-injury/fatal-accident-compensation-claims">LEARN MORE</Link></button>
                </div>
            </div>
            {/* CONTAINERS SECTION 8 */}
            <div className="inj-container-L">
                <div className="inj-content-L">
                    <h3 className="inj-content-header">Chronic Pain</h3>
                    <p className="inj-content-text">Contrary to popular belief, chronic pain is a real phenomenon that plagues thousands of people
every day, and chronic pain lawyers in Toronto are willing to hear your case and represent you
in your time of need.</p>
                    <button className="field-btn"><Link to="/fields-of-expertise/personal-injury/chronic-pain">LEARN MORE</Link></button>
                </div>
                <img src="/img/fields/injury/pi4.png" alt="A person holding their back in pain"></img>
            </div>
            {/* CONTAINERS SECTION 9 */}
            <div className="inj-container-R">
                <img src="/img/fields/injury/inj10.png" alt="A motorcycle"></img>
                <div className="inj-content-R">
                    <h3 className="inj-content-header">Motorcycle Accidents</h3>
                    <p className="inj-content-text">Do you ride a motorbike as an economical means of transportation or<br/> just to enjoy a long drive through the cool air? You deserve to be<br/> compensated if you sustain a motorcycle accident injury.</p>
                    <button className="field-btn"><Link to="/fields-of-expertise/personal-injury/motorcycle-accidents">LEARN MORE</Link></button>
                </div>
            </div>
            {/* CONTAINERS SECTION 10 */}
            <div className="inj-container-L">
                <div className="inj-content-L">
                    <h3 className="inj-content-header">Public Transit Injuries</h3>
                    <p className="inj-content-text">Depending on someone else to stay protected is risky. Transit accidents<br/> in Toronto are frequently witnessed. Consult an expert injury lawyer to<br/> deal with skilled transport agencies who can defend themselves against<br/> liability.</p>
                    <button className="field-btn"><Link to="/fields-of-expertise/personal-injury/public-transit-injuries">LEARN MORE</Link></button>
                </div>
                <img src="/img/fields/injury/inj13.png" alt="A TTC subway train"></img>
            </div>
            {/* CONTAINERS SECTION 11 */}
            <div className="inj-container-R">
                <img src="/img/fields/injury/inj12.png" alt="A person with a bicycle looking at a mountain view"></img>
                <div className="inj-content-R">
                    <h3 className="inj-content-header">Bicycle Accidents</h3>
                    <p className="inj-content-text"> If you or any cyclist you know has sustained injuries caused from a bicycle<br/> accident, it is important to protect your rights. This can be best done by<br/> consulting an experienced attorney.</p>
                    <button className="field-btn"><Link to="/fields-of-expertise/personal-injury/bicycle-accidents">LEARN MORE</Link></button>
                </div>
            </div>
            {/* nav buttons */}
            <div className="next-page-double-btn">
                <div className="next-page-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
                        <path d="M0.840374 9.59939L10.1851 15.9612C11.3584 16.76 12.8873 15.9263 12.9941 14.4904C13.002 14.3844 12.9831 14.2785 12.9499 14.1776L10.961 8.13557L12.9499 2.09351C12.9831 1.99261 13.002 1.8867 12.9941 1.78077C12.8886 0.364848 11.397 -0.472328 10.2228 0.285009L0.878026 6.31197C-0.276088 7.05633 -0.296349 8.82552 0.840374 9.59939Z" fill="#BF9874"/>
                    </svg>
                    <p><Link to="/fields-of-expertise/litigation">Litigation</Link></p>
                </div>
                <div className="next-page-btn">   
                    <p><Link to="/fields-of-expertise/real-estate">Real Estate</Link></p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
                        <path d="M12.1596 6.33849L2.81487 0.29479C1.64616 -0.461075 0.12465 0.321745 0.00723972 1.67603C-0.00238562 1.78706 0.018628 1.89822 0.0551139 2.00352L2.03901 7.72912L0.055114 13.4547C0.018628 13.56 -0.00238987 13.6712 0.00725817 13.7822C0.123306 15.1176 1.60765 15.9038 2.77722 15.1872L12.122 9.46154C13.2761 8.7544 13.2963 7.07367 12.1596 6.33849Z" fill="#BF9874"/>
                    </svg>
                </div>
            </div>
        </div>
        <Footer />
        </>
    );
}